export default __webpack_public_path__ + "static/media/sign up.f525d6fd.svg";